﻿import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";
/**
 * Custom hook to fetch timezones.
 * @returns {{timezones: Array<object>, loading: boolean}} - The list of timezones and loading state.
 */
export function useTimezones() {
  const { data, loading } = useQuery<any>(queries.getTimezones);

  return {
    timezones: data?.mongoTimezones || [],
    loading,
  };
}
